import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'
import { StatisticFilterType } from '@/shared/types'

class StatisticApi extends AxiosService {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public getHeadDoctorStatistic(filter: StatisticFilterType) {
    const { dateFrom, dateTo } = filter

    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/statistic/head-doctor',
      params: {
        date_from: dateFrom,
        date_to: dateTo,
      },
    })
  }

  public getOrganizationDynamicReportCreation(
    dateFrom: Date,
    dateTo: Date,
    maxAmount: number,
    minAmount: number,
    countOnPage: number,
    offset: number
  ) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/statistic/report-dynamics-organization',
      params: {
        date_from: dateFrom,
        date_to: dateTo,
        max_amount: maxAmount,
        min_amount: minAmount,
        count: countOnPage,
        offset: offset,
      },
    })
  }

  public getUserDynamicReportCreation(
    organizationId: string,
    dateFrom: Date,
    dateTo: Date,
    maxAmount: number,
    minAmount: number,
    countOnPage: number,
    offset: number
  ) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/statistic/report-dynamics-users',
      params: {
        organization_id: organizationId,
        date_from: dateFrom,
        date_to: dateTo,
        max_amount: maxAmount,
        min_amount: minAmount,
        count: countOnPage,
        offset: offset,
      },
    })
  }

  public getDoctorStatistic(filter: StatisticFilterType) {
    const { dateFrom, dateTo } = filter

    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/statistic/doctor',
      params: {
        date_from: dateFrom,
        date_to: dateTo,
      },
    })
  }
}

export const statisticApi = new StatisticApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
